export const getQueryParamValueByName = (name) => {
    if (typeof window === `undefined`) {
        return null
    }
    var url_string = window.location.href
    var url = new URL(url_string);
    var c = url.searchParams.get(name);
    return c
}
